import React from 'react'

const Images = () => {
  return (
    <div><img src="/"/></div>
  )
}

export default Images